export const areaValidator = (data) => {
    let isValid = true;
    const areas = [...data.areas];
    const areasToSubmit = areas.filter(a => {
        if (a.areaTypeId !== 0) {
            return true;
        }
        return false;
    });

    for (let i = 0; i < areasToSubmit.length; i++) {
        if (areasToSubmit[i].amount === '') {
            areasToSubmit[i].amount_error = 'Required';
            isValid = false;
        } else {
            areasToSubmit[i].amount_error = undefined;
        }
        if (areasToSubmit[i].description === '') {
            areasToSubmit[i].description_error = 'Required';
            isValid = false;
        } else {
            areasToSubmit[i].description_error = undefined;
        }
    }

    if (!isValid) return false;

    data.areas = areasToSubmit;

    return true;
}

export default areaValidator;